module.exports = __webpack_public_path__ + "img/4.4296a37a.png";